export default __webpack_public_path__ + "static/squid-game-50876f9e07c11c1e1371fe50bf37d431.png";